import { useContext } from 'react'
import { AiChatContext } from './aiChatContextCore'

export const useAiChat = () => {
  const context = useContext(AiChatContext)
  if (!context) throw new Error('useAiChat must be used within AiChatProvider')
  return context
}
